import { styled } from '@mui/material';

import DeclineButton from './DeclineButton';
import ViewAndApplyButton from './ViewAndApplyButton';

interface ControlsProps {
    className?: string;
    onOpenClick: () => void;
    onDeclineClick: () => void;
}

function Controls({ className, onOpenClick, onDeclineClick }: ControlsProps) {
    return (
        <Root className={ className }>
            <ViewAndApplyButton onClick={ onOpenClick } />
            <DeclineButton onClick={ onDeclineClick } />
        </Root>
    );
}

const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    marginTop: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
        button: {
            flex: 1
        }
    }
}));

export default Controls;
